/**
 * Форматує американський номер у вигляді +1 (XXX) XXX-XXXX.
 * Якщо формат не підходить (не 10 цифр або 11 з лідируючою 1), повертає вхідне значення як є.
 *
 * @param {string|number|null|undefined} phone Вхідне значення номера (наприклад, 2125551234)
 * @returns {string|null|undefined} Форматований номер або оригінальне значення, якщо невалідний
 *
 * @example
 * getFormatUSPhone('2125551234');   // "+1 (212) 555-1234"
 * getFormatUSPhone('12125551234'); // "+1 (212) 555-1234"
 * getFormatUSPhone('380988078995'); // "380988078995"
 * getFormatUSPhone('abc');          // "abc"
 */
export function getFormatUSPhone(phone) {
	if (phone == null) return phone; // null/undefined как есть

	const original = String(phone);
	const digitsRaw = original.replace(/\D/g, '');

	// Если 11 цифр и первая "1" → обрезаем её
	let digits = digitsRaw;
	if (digitsRaw.length === 11 && digitsRaw.startsWith('1')) {
		digits = digitsRaw.slice(1);
	}

	// Если не ровно 10 цифр → возвращаем как есть
	if (digits.length !== 10) {
		return original;
	}

	// Форматируем как US
	const area = digits.slice(0, 3);
	const prefix = digits.slice(3, 6);
	const line = digits.slice(6);

	return `+1 (${ area }) ${ prefix }-${ line }`;
}
